<template>
  <v-container fluid>
    <v-card v-if="checklistTransaction && checklist">
      <v-card-title primary-title style="display: block">
        {{ checklist.name }}
        <div style="float: right">
        <v-alert
          :type="checklistTransaction.state === 'Completed' ? 'success' : 'info'" :value="true"
          small
        >
          {{ checklistTransaction.state }}
        </v-alert>
        </div>
      </v-card-title>
      <v-card-subtitle v-if="checklist">
        Created by {{ checklist.createdBy }}
        <v-icon small>{{ mdiClock }}</v-icon>
          {{ formatFromNow(checklist.created) }}
      </v-card-subtitle>
      <v-card-text v-if="checklist.checklistType === 'Custom'">
        <component :is="resolveChecklist" :checklist="checklist" />
      </v-card-text>
      <v-card-text v-else>
        <v-row>
          <v-col
            cols="12"
            v-for="checklistItem in checklistTransaction.checklistItemTransactions"
            :key="checklistItem.id"
          >
            <v-checkbox
              :label="getName(checklistItem.checklistItemId)"
              v-model="checklistItem.isChecked"
              :disabled="checklistTransaction.state === 'Completed'"
              @change="onCheckboxChange(checklistItem, $event)"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="secondary" @click="save"
          :disabled="checklistTransaction.state === 'Completed'">Save</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="complete"
          :disabled="checklistTransaction.state === 'Completed'">Complete</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiClock } from '@mdi/js';
import FireEquipmentHealth from '../components/FireEquipmentHealth.vue';
import PurgeChecklist from '../components/PurgeChecklist.vue';

export default {
  name: 'Checklist',
  components: {
    FireEquipmentHealth,
    PurgeChecklist,
  },
  data() {
    return {
      mdiClock,
      id: undefined,
    };
  },
  computed: {
    ...mapState('checklistTransactions', ['checklistTransaction']),
    ...mapState('checklists', ['checklist']),
    ...mapState('checklistItems', ['checklistItems']),
    resolveChecklist() {
      switch (this.checklist.name) {
        case 'Purging':
          return 'PurgeChecklist';
        case 'Fire Equipment Health':
          return 'FireEquipmentHealth';
        default:
          return 'div';
      }
    },
  },
  methods: {
    ...mapActions('checklistTransactions', ['LOAD_checklistTransaction', 'UPDATE_checklistTransaction']),
    ...mapActions('checklistItemTransactions', ['UPDATE_checklistItemTransaction']),
    ...mapActions('checklists', ['LOAD_checklist']),
    ...mapActions('checklistItems', ['LOAD_checklistItems']),
    getName(id) {
      const checklistItem = this.checklistItems.find((item) => item.id === id);
      return checklistItem ? checklistItem.name : '';
    },
    async onCheckboxChange(checklistItem) {
      await this.UPDATE_checklistItemTransaction(checklistItem);
      await this.refresh();
    },
    async refresh() {
      this.isLoading = true;
      console.debug(this.id);
      await this.LOAD_checklistTransaction(this.id);
      const { checklistId } = this.checklistTransaction;
      await Promise.all([
        (async () => {
          await this.LOAD_checklist(checklistId);
        })(),
        (async () => {
          await this.LOAD_checklistItems(checklistId);
        })(),
      ]);
      this.isLoading = false;
    },
    async complete() {
      this.isSaving = true;
      await this.UPDATE_checklistTransaction({
        id: this.id,
        state: 'Completed',
      });
      this.isSaving = false;
      this.$router.push({ name: 'checklists-Checklists' });
    },
    async save() {
      this.isSaving = true;
      await this.UPDATE_checklistTransaction({
        id: this.id,
        state: 'Active',
      });
      this.isSaving = false;
      this.$router.push({ name: 'checklists-Checklists' });
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.refresh();
  },
};
</script>
